var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoRiskTrend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36491_87482)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 75,
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.875 60.3334V165.333H98.125V60.3334C98.125 53.9167 95.5 48.6667 87.625 48.6667H82.375C74.5 48.6667 71.875 53.9167 71.875 60.3334Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 95.3334V165.333H55.8333V95.3334C55.8333 88.9167 53.5 83.6667 46.5 83.6667H41.8333C34.8333 83.6667 32.5 88.9167 32.5 95.3334Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.167 124.5V165.333H137.5V124.5C137.5 118.083 135.167 112.833 128.167 112.833H123.5C116.5 112.833 114.167 118.083 114.167 124.5Z",
    fill: "#CBD5E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36491_87482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRiskTrend);
export default __webpack_public_path__ + "static/media/No-risk-trend.eed6c2dcb43e108056c390b470351532.svg";
export { ForwardRef as ReactComponent };